export default __webpack_public_path__ + "static/media/Bengali_book_m.3f1f429c.wav";